import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Field from '../../../../../../../../../components/Form/Field'
import RadioBlock from '../../../../../../../../../components/Form/RadioBlock'

import { choicesPixelsLoadingSelector } from '../../../../../../../../../modules/selectors/choices'
import { pixelStatsIsLoadingSelector } from '../../../../../../../../../modules/selectors/lineItems'
import { selectedFacebookAdAccountSelector } from '../../../../../../../../../modules/selectors/adAccounts'

import {
  CUSTOM_EVENT_TYPE,
  PROMOTED_PIXEL
} from '../../../../../../../../../constants/selectLists/customEventTypes/fields'
import { TARGET_COST_CAP } from '../../../../../../../../Multiplatform/LineItemForms/fields'

import { CONVERSION_EVENT_TYPE_RADIO_BUTTON, STANDARD_DATASET_EVENT } from '../../../../fields'

const StandardDatesetEventRadioBlock = ({ formik, formattedPixels, eventTypeOptions, showTargetCostCapField }) => {
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const { currency_symbol: currencySymbol } = useSelector(selectedFacebookAdAccountSelector)
  const pixelsIsLoading = useSelector(choicesPixelsLoadingSelector)
  const pixelStatsIsLoading = useSelector(pixelStatsIsLoadingSelector)

  return (
    <RadioBlock
      setFieldValue={setFieldValue}
      name={CONVERSION_EVENT_TYPE_RADIO_BUTTON}
      id={STANDARD_DATASET_EVENT}
      value={STANDARD_DATASET_EVENT}
      label={t('Standard dataset (pixel) event')}
      selectedValue={values[CONVERSION_EVENT_TYPE_RADIO_BUTTON]}
    >
      <h3>{t('Select the dataset and event to optimise towards.')}</h3>
      <Field
        placeholder={t('Event Source')}
        formik={formik}
        name={PROMOTED_PIXEL}
        options={formattedPixels}
        isLoading={pixelsIsLoading}
        preselectFirstOptionValue
      />
      <Field
        placeholder={t('Event')}
        formik={formik}
        isLoading={pixelStatsIsLoading}
        name={CUSTOM_EVENT_TYPE}
        options={eventTypeOptions}
      />
      {showTargetCostCapField && (
        <Field
          type="number"
          formik={formik}
          name={TARGET_COST_CAP}
          placeholder={t('Average Cost Goal')}
          symbol={currencySymbol}
          autoComplete="off"
        />
      )}
    </RadioBlock>
  )
}

StandardDatesetEventRadioBlock.propTypes = {
  formik: PropTypes.object,
  formattedPixels: PropTypes.array,
  eventTypeOptions: PropTypes.array,
  showTargetCostCapField: PropTypes.bool
}

export default StandardDatesetEventRadioBlock
